import { includes, keys } from 'lodash'

export * from './intlHelpers'
export * from './inputFormatters'
export * from './intlTestHelpers'
export * from './regexConstants'
export { numberToDollars, numberToCurrency } from './numberToCurrency'
export * from './mockedValues'
export { isDateBeforeToday, isOneDateBeforeAnotherDate } from './dateUtil'

//Get a setting (by key) from window.APP_CONFIG (from config.js).
//If the setting does not exist, return an optional defaultValue or undefined.
export function getAppConfigSetting(key: string, defaultValue?: string) {
  // @ts-ignore
  const config = typeof window !== 'undefined' ? window.appConfig || {} : {}
  let value
  if (includes(keys(config), key)) {
    //config keys are allowed to have mustache template values referencing APP_CONFIG
    value = config[key]
  }
  return value === undefined ? defaultValue : value
}
